var _style, _path, _path2, _g, _g2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgQuick(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1684 1190",
    width: 1684,
    height: 1190,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Business man 04-ai") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n\t\t.s0 { fill: #ffffff } \n\t\t.s1 { fill: #b4e4f9 } \n\t\t.s2 { fill: #4967aa } \n\t\t.s3 { fill: #1d4170 } \n\t\t.s4 { fill: #ecf3fc } \n\t\t.s5 { fill: #dd735b } \n\t\t.s6 { fill: #f89a78 } \n\t\t.s7 { fill: #672949 } \n\t\t.s8 { fill: #1c3f6f } \n\t\t.s9 { fill: #757575 } \n\t\t.s10 { fill: #fbfffc } \n\t\t.s11 { fill: #a8a9ab } \n\t\t.s12 { fill: #1c4b63 } \n\t\t.s13 { fill: #2c72b7 } \n\t\t.s14 { fill: #3f81cd } \n\t\t.s15 { fill: #2066a0 } \n\t\t.s16 { fill: #c6284e } \n\t\t.s17 { fill: #e74264 } \n\t\t.s18 { fill: #a51b42 } \n\t\t.s19 { fill: #3eb2c1 } \n\t\t.s20 { fill: #5dcae1 } \n\t\t.s21 { fill: #2797a0 } \n\t\t.s22 { fill: #3a4cb5 } \n\t\t.s23 { fill: #5161db } \n\t\t.s24 { fill: #283b8c } \n\t\t.s25 { fill: #e2917f } \n\t\t.s26 { fill: #ffb7a2 } \n\t\t.s27 { fill: #b56a5d } \n\t")), /*#__PURE__*/React.createElement("g", {
    id: "Layer 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m1683.8 1190h-1683.8v-1190.6h1683.8z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>",
    style: {
      opacity: 0.5
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m82.2 503.9c-35.5-28.5-58-73.2-58.6-118.9-1.3-93.3 92.2-168.5 183.8-158.8 84.1 8.8 146.1 99.5 230.6 97.3 64.9-1.8 113.5-57.3 155.9-106.4 51.6-59.6 108.2-117.3 178.9-152.2 70.6-35 158.2-44 227.4-6.2 30.9 16.9 58 44.5 65.2 79 7.3 35.1-6.7 70.6-14.5 105.6-7.8 35-6.8 77.4 21.5 99.5 10.3 8.1 23.2 12.3 36.1 15.1 78.4 16.5 156.9-18.8 234.1-40.5 77.1-21.6 173.2-23.9 223 38.8 35.3 44.4 34.4 110.5 7.3 160.4-27.1 49.8-76.1 84.7-128.4 106.5-52.4 21.8-108.7 31.9-164.2 43.4-23.1 4.9-51.6 16.3-51.5 39.8 0.1 10.1 5.8 19.1 11.5 27.4 25.5 37 54.8 72.2 71 114.1 16.2 41.9 16.7 93.6-12.5 127.8-22.4 26.1-57.4 37.2-91 44.7-60 13.4-127.1 18.2-178.9-14.9-36.3-23.2-59.5-61.5-85.7-95.7-26.1-34.3-60.1-67.5-103-72-69.3-7.3-117.7 54-162.3 95.7-54 50.6-136.3 88.1-205.1 112.9-77.7 28-162.1 40.4-243.8 27.9-26.1-3.9-53.9-11.7-70-32.6-25.3-32.6-10.6-80.6 11.8-115.3 22-33.8 50.4-63.5 83.3-86.9 34.6-24.6 73.9-42.2 106.8-69 32.9-26.8 59.7-66.7 55.1-108.8-4.4-41.3-38.1-74.5-76.2-91-38-16.6-80.3-19.7-121.5-23.9-41.3-4.1-83.7-10.1-119.4-31.2q-8.7-5.3-16.7-11.6z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s2",
    d: "m1458.8 922.6h-1401.5v-56.4h1401.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s3",
    d: "m194.2 1041.4h-30.1l36.3-118.8h44.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s3",
    d: "m1232 1041.4h-30.1l-50.5-118.8h44.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s2",
    d: "m1164.6 781.4h-661.6c-13.2 0-22.9-12.2-19.9-25l98.5-426.1c2.2-9.3 10.4-15.8 19.9-15.8h661.6c13.2 0 22.9 12.2 19.9 25l-98.5 426.1c-2.1 9.2-10.4 15.8-19.9 15.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s4",
    d: "m1135.4 694.8h-568.1c-13.1 0-22.8-12.2-19.8-24.9l69.8-302c2.1-9.3 10.4-15.8 19.8-15.8h568.2c13.1 0 22.8 12.2 19.8 25l-69.8 301.9c-2.1 9.3-10.4 15.8-19.9 15.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s3",
    d: "m832.1 866.2l-5.4-15.6h9.4 131.6l-23.9-69.2h20.3l29.3 84.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s3",
    d: "m959.4 844h-119.1l-21.6-62.6h119.1z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m434 523.6q0.1 9.2 0.6 18.4c-9.2-4.5-17.9-9.9-26-16.2 8.7 0.3 17.3-0.2 25.4-2.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s6",
    d: "m463.6 501.1c-1.6 6.5-6.7 11.7-12.4 15.3-5.4 3.4-11.2 5.7-17.2 7.2-8.1 2-16.7 2.5-25.4 2.2 8.1 6.3 16.8 11.7 26 16.2q0.3 6.3 0.8 12.6c-7-3.5-14.5-6.2-22.1-8.6-23.1-7.5-42.7-10.7-66.6-6.3q0.6-10.8 0.3-21.7c1.5 0.3 3.1-0.3 4.5-0.9 21.4-9 44.7-23.1 47.6-46.1-9 0.1-17.7-5.2-21.8-13.2-4.1-8-3.3-18.2 2-25.4 2.5-3.5 6.3-6.5 10.7-6.6 5.5-0.3 10.4 4 12.6 9.1 2.2 5 2.3 10.7 2.4 16.2 10.6-5.2 8.6-22.5 18.3-29.2 4.7-3.2 10.7-3 16.1-4.8 3.9-1.2 7.2-3.4 10-6.2 6.5 25.8 11.3 52 14.3 78.4 0.4 3.9 0.8 7.9-0.1 11.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s6",
    d: "m789.8 696.2c0.4-0.2 0.8-0.4 1.2-0.3 1.1 0.2 1.4 1.5 1.4 2.5 0 5.3-2.5 10.3-5.4 14.6-1.2 1.7-7.8 6-7.8 7.7 0.1 3.1-1.2 6.3-3.2 8.8-1.7 2.1-3.9 3.9-6.2 5.4-1 5.8-6.7 10.9-12.3 13.9-12.2 6.5-25.9 6.8-37.2 14.4q-2.6 1.8-5.1 3.7c1.3-8.1-2.6-15.8-9.3-21.7-5.9-5.2-14-8.6-21.6-11.4-1.1-0.4-2.3-0.8-3.5-1 7.1-9.8 13.1-20.7 19.7-30.9 9.7-14.9 22.1-29.3 38.9-34.9 1 6-0.3 12.4-3.6 17.4-2.2 3.4-5.4 6.7-4.7 10.7 0.6 3.7 4.7 6 8.5 5.9 3.7 0 7.2-1.8 10.6-3.5q17.4-9.2 34.9-18.3c3.8 5.6-1.5 12.7-6.4 17.4-5.1 4.8-10.7 9.5-15.5 14.7-0.7 0.7 5.2 0.4 5.7 0.2 1.9-0.7 3.9-2.1 5.6-3 4.2-2.3 8.1-5.3 11.4-8.8 0.8-0.9 1.7-1.9 2.6-2.7q0.6-0.4 1.3-0.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m475.8 603c-12-7-24.4-13.6-37.1-19.5-23.7-11-48.6-19.6-74.9-24.5-6.1-1.1-12.4-2.1-18.6-2.3q-2.5-0.1-5 0c1.9-5.6 3.8-11.2 5.6-16.8q0.5-0.1 0.9-0.2c23.9-4.4 43.5-1.2 66.6 6.3 7.6 2.4 15.1 5.1 22.1 8.6 4.8 2.3 9.3 5 13.4 8.1 13.5 10.5 21 25.2 27 40.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s7",
    d: "m732.7 1041.4h-420.5q-0.1-0.1-0.1-0.2c-3.1-17.8-4.5-36.3-0.8-53.8 29.9 1.9 59.9 1.9 89.9 1.9q70.7 0.1 141.4 0.1c7.9 0 15.8 0.4 23.5 1 30.4 2.5 59.9 9.4 89.4 18.9 26.6 8.5 52.4 19.3 77.2 32.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s8",
    d: "m566.1 990.4c-7.7-0.6-15.6-1-23.5-1q-70.7 0-141.4-0.1c-30 0-60 0-89.9-1.9q-1.3-0.1-2.6-0.1c-1.1-46.6 3.1-93.2-6.7-139.2-3.4-16.2-8.6-32-13.1-47.9-13.3-47.3-21-95.8-22.8-144.5-0.3-8.8-0.4-17.7 1.6-26.3 3.5-15 13.4-28.2 23.3-40.8 10.2-12.9 22-26.6 39.4-30.6 3.2-0.8 6.5-1.2 9.8-1.3q2.5-0.1 5 0c6.2 0.2 12.5 1.2 18.6 2.3 26.3 4.9 51.2 13.5 74.9 24.5 12.7 5.9 25.1 12.5 37.1 19.5q2.2 1.3 4.4 2.6c4.6 2.8 9.2 5.7 12.2 9.8 2.1 2.9 3.2 6.3 4.1 9.6-15.9-8-37.1-9.1-50.2 1.7-6.5 5.3-10.1 12.7-12.8 20.1-7.9 21.9-9 45.3-5.1 68 2 11.6 5.3 23.2 10.6 34 4 8.3 9.2 16.2 13.8 24.3 14.5 26 22.3 54.7 39.4 79.5 10.4 15 24.1 28.3 40 38.9 8.7 5.8 17.9 12.2 28.7 14.6q0.1 0 0.1 0c3.4 28 5.1 56.1 5.1 84.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s7",
    d: "m461.1 385c-1.4 9.5-5.1 19.4-11.7 25.9-2.8 2.8-6.1 5-10 6.2-5.4 1.8-11.4 1.6-16.1 4.8-9.7 6.7-7.7 24-18.3 29.2-0.1-5.5-0.2-11.2-2.4-16.2-2.2-5.1-7.1-9.4-12.6-9.1-4.4 0.1-8.2 3.1-10.7 6.6-5.3 7.2-6.1 17.4-2 25.4 4.1 8 12.8 13.3 21.8 13.2-2.9 23-26.2 37.1-47.6 46.1-1.4 0.6-3 1.2-4.5 0.9q-0.4-0.1-0.8-0.2c-1.8-0.8-2.6-2.8-3.4-4.6-5.7-14.2-15.9-25.9-25-38.2-9.1-12.2-17.5-25.9-18.7-41.1-1.2-15.2 7-32.1 21.7-36.2 3.2-0.9 6.6-1.2 9.3-3.1 2.2-1.6 3.6-4.1 5-6.5 16.2-28.1 45.4-47.2 77.1-52.8 31.3-5.5 53.6 17.5 48.9 49.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m715.2 766.9q-0.5 2.9-1.8 5.7c-2 4-5.1 7.4-8.1 10.8-20.7 22.7-39.3 46.9-60.3 69.5-15.8 16.9-32 34.5-53.5 46.1-9.6 5.2-18.9 9.6-30.5 7.1q0 0-0.1 0c-10.8-2.4-20-8.8-28.7-14.6-15.9-10.6-29.6-23.9-40-38.9-17.1-24.8-24.9-53.5-39.4-79.5-4.6-8.1-9.8-16-13.8-24.3-5.3-10.8-8.6-22.4-10.6-34-3.9-22.7-2.8-46.1 5.1-68 2.7-7.4 6.3-14.8 12.8-20.1 13.1-10.8 34.3-9.7 50.2-1.7q3 1.6 5.8 3.5c58.6 40.2 29.8 116.8 58 169.4 1.1 2.2 2.6 4.5 5.2 5.3 2.2 0.7 4.7 0.1 6.9-0.6 19.5-5.9 36.3-17 52.8-27.9 17.8-11.8 35.8-23.8 49.8-39 1-1.1 2.1-2.3 3.6-2.7 0.7-0.2 1.5-0.2 2.2-0.2 1.2 0.2 2.4 0.6 3.5 1 7.6 2.8 15.7 6.2 21.6 11.4 6.7 5.9 10.6 13.6 9.3 21.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m779.3 720.8l-3.8 2.6q-2 1.2-4.1 2.1c-2.7 1.3-5.6 2.4-8.5 3.5-5.7 2.1-11.6 3.9-16.8 7l-0.5-1c4.6-2.7 9.8-4.5 14.8-6.2 2.5-0.9 5-1.7 7.5-2.7l7.4-3c0.1 0 0.1 0 0.2 0.1q0 0.1-0.1 0.1c-2.2 1.6-4.6 2.8-7.1 3.7-2.5 1-5 1.9-7.6 2.8-5 1.8-10 3.6-14.6 6.2-0.3 0.1-0.6 0-0.8-0.2-0.1-0.3 0-0.6 0.2-0.8h0.1c5.4-3 11.2-5 17-6.9 2.9-1 5.8-2 8.6-3.2 1.4-0.6 2.7-1.3 4.1-1.9l3.8-2.5h0.1c0 0 0.1 0 0.1 0.1q0.1 0.1 0 0.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m769.9 735c-2.2 1.9-4.6 3.3-7.1 4.7q-3.7 2-7.6 3.9c-5.1 2.4-10.3 4.5-15.7 6.2l-0.4-1q7.1-2.3 13.9-5.3c4.6-2 9-4.2 13.4-6.6 0.1-0.1 0.2 0 0.2 0q0.1 0.2 0 0.2c-4.3 2.7-8.7 5-13.2 7.2-4.5 2.1-9.2 3.9-13.9 5.5-0.3 0.1-0.6 0-0.7-0.3-0.1-0.3 0-0.6 0.3-0.7 5.4-1.8 10.6-3.9 15.7-6.2q3.8-1.8 7.5-3.8l3.7-2.1q1.8-1 3.8-1.9c0-0.1 0.1 0 0.1 0q0.1 0.1 0 0.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m763.5 711.2c-0.7 0.8-1.6 1.2-2.5 1.7q-1.4 0.6-2.8 1.2-2.7 1.2-5.6 2.1c-3.8 1.3-7.8 2.2-11.8 2.6-0.1 0-0.1 0-0.1-0.1q0-0.1 0.1-0.2c3.9-1 7.7-2 11.5-3.3q2.8-1 5.5-2.1 1.4-0.6 2.8-1.2c0.9-0.4 1.7-0.8 2.8-0.9 0.1-0.1 0.2 0 0.2 0.1q0 0.1-0.1 0.1z"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s9",
    d: "m704.3 553.7l197.2-4.4 1.9 2-31.2 128.8-194.8-0.6-1.8-2z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s10",
    d: "m702.5 551.7l199-2.4-31.3 128.8-194.6-0.6z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s11",
    d: "m726.8 565.5l-22.4 0.4c-0.8 0-1.4-0.7-1.4-1.4 0.1-0.8 0.8-1.5 1.7-1.4l22.3-0.4c0.8 0 1.5 0.6 1.4 1.4-0.1 0.8-0.8 1.4-1.6 1.4z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s11",
    d: "m756 573l-52.1 0.6c-0.9 0-1.5-0.7-1.5-1.5 0.1-0.8 0.8-1.4 1.7-1.4l52.1-0.6c0.9 0.1 1.5 0.7 1.5 1.5-0.1 0.8-0.8 1.4-1.7 1.4z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s12",
    d: "m871.5 597.1l4.1 3.5-15.7 69h-28.5l-3.5-3.5h28z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s12",
    d: "m843.5 561l3.9 3.4-25.8 106.1h-28.6l-3.4-3.5h27.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s12",
    d: "m800.2 584.3l3.8 3.5-20.8 83.3h-27.4l-3.3-3.5h26.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s12",
    d: "m754.3 628.7l3.7 3.5-10.5 38.6h-27.4l-3.2-3.4 26.8-0.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s12",
    d: "m720.1 619.7l3.7 3.5-13.3 47.1-27.2-1-3.2-3.5 26.6 1z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s13",
    d: "m871.1 596.3l4 3.5-15.6 69h-28.5l-3.5-3.5h27.9z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s14",
    d: "m871.1 596.3l-15.7 69h-28.5l17-67.8z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s15",
    d: "m855.4 665.3l4.1 3.5h-28.5l-3.5-3.5z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s16",
    d: "m843.1 560.1l3.9 3.5-25.8 106.1h-28.6l-3.4-3.6 27.9 0.1z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s17",
    d: "m843.1 560.1l-26 106.1-28.5-0.1 27.4-104.7z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s18",
    d: "m817.1 666.2l4.1 3.5h-28.6l-3.4-3.6z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s19",
    d: "m799.8 583.5l3.7 3.5-20.8 83.2-27.3 0.1-3.3-3.5 26.8-0.1z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s20",
    d: "m799.8 583.5l-20.9 83.2-27.3 0.1 22.1-82.1z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s21",
    d: "m778.9 666.7l3.8 3.5-27.3 0.1-3.3-3.5z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s22",
    d: "m753.9 627.9l3.7 3.5-10.5 38.6h-27.4l-3.2-3.5h26.8z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s23",
    d: "m753.9 627.9l-10.6 38.6h-27.4l11.5-37.4z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s24",
    d: "m743.3 666.5l3.8 3.5h-27.4l-3.2-3.5z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s25",
    d: "m719.7 618.9l3.7 3.5-13.3 47.1-27.2-1-3.2-3.5 26.6 1z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s26",
    d: "m719.7 618.9l-13.4 47.1-27.2-1 14.4-46z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s27",
    d: "m706.3 666l3.8 3.5-27.2-1-3.2-3.5z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s12",
    d: "m928.4 625l26.8-0.7-3.3 14.1-26.8 0.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s12",
    d: "m923.5 645.8l26.8-0.6-3.3 14.2-26.9 0.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s12",
    d: "m938.3 583.3l26.6-1.1-3.3 14.2-26.6 1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s12",
    d: "m933.4 604.2l26.6-1-3.3 14.2-26.7 0.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s12",
    d: "m966.4 575.4l-26.5 1.2 3.4-14.2 26.4-1.3z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s17",
    d: "m928.7 623.5l26.7-0.8-3.3 14.2-26.8 0.7z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s14",
    d: "m923.7 644.3l26.8-0.6-3.3 14.2-26.9 0.5z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s23",
    d: "m938.6 581.8l26.5-1.1-3.3 14.2-26.6 1z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s20",
    d: "m933.6 602.7l26.6-1-3.2 14.2-26.7 0.9z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s26",
    d: "m966.7 573.9l-26.5 1.2 3.3-14.2 26.4-1.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s11",
    d: "m1025.6 564.8l-49.6 2c-0.4 0-0.6-0.3-0.6-0.8 0.1-0.4 0.5-0.7 0.9-0.7l49.5-2.1c0.5 0 0.7 0.4 0.7 0.8-0.1 0.5-0.5 0.8-0.9 0.8z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s11",
    d: "m1039.4 568.4l-64 2.6c-0.4 0-0.6-0.4-0.6-0.8 0.1-0.4 0.5-0.8 0.9-0.8l63.9-2.6c0.4 0 0.7 0.4 0.6 0.8-0.1 0.5-0.4 0.8-0.8 0.8z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s11",
    d: "m1020.4 586.6l-49.8 1.7c-0.4 0-0.7-0.4-0.6-0.8 0.1-0.5 0.5-0.8 0.9-0.8l49.7-1.7c0.4 0 0.7 0.4 0.6 0.8 0 0.5-0.4 0.8-0.8 0.8z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s11",
    d: "m1034.2 590.3l-64.2 2.1c-0.4 0-0.7-0.3-0.6-0.8 0.1-0.4 0.4-0.7 0.9-0.7l64.1-2.2c0.4 0 0.7 0.4 0.6 0.8-0.1 0.5-0.4 0.8-0.8 0.8z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s11",
    d: "m1015.1 608.4l-49.9 1.3c-0.4 0-0.7-0.4-0.6-0.8 0-0.4 0.4-0.8 0.8-0.8l49.9-1.3c0.5 0 0.7 0.4 0.7 0.8-0.1 0.4-0.5 0.8-0.9 0.8z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s11",
    d: "m1028.9 612.2l-64.3 1.6c-0.4 0-0.7-0.3-0.6-0.8 0-0.4 0.4-0.7 0.8-0.7l64.4-1.7c0.4 0 0.7 0.4 0.6 0.8-0.1 0.4-0.4 0.8-0.9 0.8z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s11",
    d: "m1009.9 630.1l-50.1 1c-0.4 0-0.7-0.4-0.7-0.8 0.1-0.5 0.5-0.8 0.9-0.8l50.1-1c0.4 0 0.7 0.4 0.6 0.8-0.1 0.5-0.4 0.8-0.8 0.8z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s11",
    d: "m1023.7 634l-64.6 1.2c-0.4 0-0.6-0.3-0.6-0.8 0.1-0.4 0.5-0.7 0.9-0.7l64.5-1.3c0.4 0 0.7 0.4 0.7 0.8-0.1 0.5-0.5 0.8-0.9 0.8z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s11",
    d: "m1004.6 651.8l-50.3 0.6c-0.4 0-0.7-0.4-0.6-0.8 0-0.4 0.4-0.8 0.8-0.7l50.3-0.7c0.4 0 0.7 0.4 0.6 0.8 0 0.5-0.4 0.8-0.8 0.8z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s11",
    d: "m1018.5 655.8l-64.8 0.8c-0.4 0-0.7-0.4-0.6-0.8 0-0.5 0.4-0.8 0.8-0.8l64.8-0.8c0.4 0 0.7 0.4 0.6 0.8 0 0.5-0.4 0.8-0.8 0.8z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s2",
    d: "m676.4 507.2h-0.6l7.4-36.8h0.6z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s2",
    d: "m697.4 497.9h-0.7l10.9-54.2h0.6z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s2",
    d: "m717.6 491.6h-0.6l12.8-63.8h0.6z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s2",
    d: "m741.5 467.5h-0.7l14.8-74.2h0.7z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s2",
    d: "m753.2 504.4h-0.7l18.2-91.6h0.6z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s2",
    d: "m766.7 532.2h-0.6l14.1-71.2h0.6z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s2",
    d: "m784.5 538.9h-0.7l18.1-91.7h0.6z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s2",
    d: "m808.6 513.2h-0.7l16.3-82.8h0.6z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s2",
    d: "m832.7 487h-0.6l23.4-119.8h0.6z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s2",
    d: "m860.2 443.6h-0.6l15.7-80.6h0.6z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s2",
    d: "m879.7 441h-0.6l11.2-57.7h0.6z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s2",
    d: "m889.6 488.1h-0.6l15.8-81.9h0.6z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s2",
    d: "m906.8 497.9h-0.7l6.1-31.6h0.7z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s2",
    d: "m920.5 525.8h-0.7l13.2-68.8h0.6z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s2",
    d: "m940.3 521.6h-0.6l15.8-82.7h0.6z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s2",
    d: "m959.4 521.5h-0.6l16.3-85.9h0.6z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s2",
    d: "m978.8 519.8h-0.6l12.5-66.4h0.7z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s2",
    d: "m996.8 525.3h-0.6l19.8-105.5h0.7z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s2",
    d: "m1025 476.8h-0.7l10.3-54.6h0.6z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s2",
    d: "m1044.6 473.4h-0.6l18-96.3h0.6z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s2",
    d: "m1059.6 495.2h-0.6l20.6-111.1h0.6z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s2",
    d: "m1074 520h-0.6l15.7-84.9h0.7z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s2",
    d: "m1090.8 532.2h-0.6l16.8-91.3h0.7z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s2",
    d: "m1123.2 459.9h-0.7l12.3-66.8h0.7z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s20",
    d: "m684.2 499.4h-13.1l2.7-13.1h13.1z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s20",
    d: "m705.9 486.1h-13.1l4.3-21.2h13.1z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s20",
    d: "m729.2 464.9h-13.1l4.5-22.6h13.1z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s20",
    d: "m748.2 464.9h-13.1l6.8-34h13.1z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s16",
    d: "m765.1 475.5h-13.1l9-44.9h13z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s16",
    d: "m775.4 519.7h-13.1l8.8-44.2h13z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s20",
    d: "m798.3 500.4h-13.1l5-25.2h13z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s20",
    d: "m817.3 500.5h-13.1l7.9-40.1h13.1z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s20",
    d: "m844.2 460.4h-13.1l10.2-52.2h13z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s20",
    d: "m873.3 408.3h-13.1l5.3-26.9h13z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s17",
    d: "m888.5 427.8h-13.1l3.7-19.1h13.1z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s17",
    d: "m898 477.1h-13.1l9.5-49.3h13.1z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s17",
    d: "m914.1 492h-13.1l2.9-14.7h13.1z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s20",
    d: "m928.2 518h-13.1l7.8-40.6h13.1z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s20",
    d: "m947.3 518h-13.1l9.2-48.6h13.1z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s20",
    d: "m975.5 469.5h-13.1l4.9-25.5h13z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s16",
    d: "m988.1 503.7h-13.1l6.5-34.4h13.1z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s20",
    d: "m1007.1 503.9h-13.1l8.9-47.5h13.1z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s20",
    d: "m1035.1 456.1h-13.1l2.4-13.1h13.1z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s20",
    d: "m1056.5 443.1h-13.1l8.4-44.5h13z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s16",
    d: "m1072.7 457.9h-13l11.1-59.5h13z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s16",
    d: "m1084.2 498.8h-13.1l7.5-40.7h13.1z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s20",
    d: "m1103.3 498.7h-13.1l9.4-51h13z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s20",
    d: "m1131.6 447.9h-13.1l3.6-19.3h13z"
  }))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuick);
export default __webpack_public_path__ + "static/media/quick.661393c11d0a4d8496f30c197800abda.svg";
export { ForwardRef as ReactComponent };